import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X } from "lucide-react";
import { useAuth } from "@/lib/auth";

const KEY = "bb-guest-banner-dismissed";

export const GuestBanner = () => {
  const { user } = useAuth();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  if (!user?.is_guest || hidden) return null;
  const dismiss = () => {
    sessionStorage.setItem(KEY, "1");
    setHidden(true);
  };
  return (
    <div data-testid="guest-banner" className="relative mb-8 flex flex-col sm:flex-row sm:items-center gap-4 rounded-2xl border border-t-c2-line bg-t-c2-soft/70 px-5 py-4 fade-up">
      <div className="h-9 w-9 shrink-0 rounded-xl bg-t-c2 text-white flex items-center justify-center"><Sparkles className="h-4 w-4" /></div>
      <p className="flex-1 text-sm text-t-ink pr-6">
        <span className="font-semibold">You're trying Base and Balance as a guest.</span>{" "}
        <span className="text-t-muted">Your lists are kept on this browser for now. Create a free account to save them and use them anywhere.</span>
      </p>
      <div className="flex gap-2 shrink-0">
        <Link to="/login?mode=signup" data-testid="guest-banner-signup" className="px-4 py-2 rounded-xl bg-t-primary hover:bg-t-primary-hover text-white text-sm font-medium transition-colors">Create account</Link>
        <Link to="/login" data-testid="guest-banner-signin" className="px-4 py-2 rounded-xl border border-t-line bg-t-card text-sm font-medium hover:bg-t-surface transition-colors">Sign in</Link>
      </div>
      <button data-testid="guest-banner-dismiss" onClick={dismiss} className="absolute top-3 right-3 p-1 rounded-md text-t-muted hover:bg-t-card/70"><X className="h-4 w-4" /></button>
    </div>
  );
};
